import { ReactElement, Suspense, useEffect } from 'react';
import './assets/styles/App.scss';
import { useRoutes, useNavigate, useLocation } from 'react-router-dom';
import routeElements from './routes/Routes';
import { ThemeProvider } from '@mui/material/styles';
import { LinearProgress } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import themeBuilder from './assets/styles/theme';
import { useSelector } from 'react-redux';
import { DefaultTheme } from 'state/baseapplication/Reducer';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ToastContainer } from 'react-toastify';

const App = (): ReactElement => {
    const navigate = useNavigate();
    const isUserLoggedIn = useSelector(
        (state: any) => state.authState.isUserLoggedIn
    );
    const role = useSelector((state: any) => state.authState.role);
    const userInfo = useSelector((state: any) => state.profileState.userInfo);
    const routes: any = useRoutes(
        // eslint-disable-next-line no-underscore-dangle
        routeElements(isUserLoggedIn, role, userInfo._id)
    );

    const themeConfig = useSelector((state: any) => {
        const { theme } = state.baseAppState;
        const pattern = /^#[0-9A-F]{6,}$/i;
        if (!pattern.test(theme.primary)) {
            theme.primary = DefaultTheme.primary;
        }
        if (!pattern.test(theme.primaryContrast)) {
            theme.primaryContrast = DefaultTheme.primaryContrast;
        }
        if (!pattern.test(theme.textPrimary)) {
            theme.textPrimary = DefaultTheme.textPrimary;
        }
        return theme;
    });
    const location = useLocation();

    useEffect(() => {
        const channel = new BroadcastChannel('perpetual-auth-chanel');

        // Listen for token updates from other tabs.
        channel.onmessage = (event) => {
            if (
                event.data.type === 'AUTH_STATE' &&
                event.data.loggedIn &&
                ((window.history.state &&
                    location.key === window.history.state.key) ||
                    typeof window.history.state === 'undefined')
            ) {
                setTimeout(() => {
                    navigate('/dashboard', { replace: true });
                }, 500);
            }
        };

        return () => {
            channel.close();
        };
    }, []);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <ThemeProvider theme={themeBuilder(themeConfig)}>
                <ToastContainer autoClose={5000} closeOnClick />

                <Suspense fallback={<LinearProgress color="primary" />}>
                    {routes}
                </Suspense>
            </ThemeProvider>
        </LocalizationProvider>
    );
};
export default App;
